import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "all_moonheads" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "title has-text-centered" }, "All MoonHeads", -1)
const _hoisted_4 = { class: "columns is-multiline is-centered is-gapless" }
const _hoisted_5 = { class: "box for-sale" }
const _hoisted_6 = { class: "for-sale-video video-parent" }
const _hoisted_7 = {
  "data-atropos-offset": "2",
  class: "overlay"
}
const _hoisted_8 = { class: "tag is-medium is-primary" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "tag is-medium is-primary" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "tag is-medium is-primary" }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "tag is-medium is-primary" }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { class: "tag is-medium is-primary" }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = { class: "tag is-medium is-primary" }
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "content" }
const _hoisted_22 = {
  "data-atropos-offset": "5",
  class: "media"
}
const _hoisted_23 = { class: "media-left-for-sale" }
const _hoisted_24 = { class: "sprite-image image is-64x64" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "media-content" }
const _hoisted_27 = { class: "title is-4" }
const _hoisted_28 = { class: "has-text-centered" }
const _hoisted_29 = ["href"]
const _hoisted_30 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_atropos = _resolveComponent("atropos")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.moonheads, (set, setKey) => {
        return (_openBlock(), _createElementBlock("div", { key: setKey }, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(set.characters, (character, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "column is-half-tablet is-one-third-desktop is-one-third-widescreen has-text-centered"
              }, [
                _createVNode(_component_atropos, {
                  duration: 250,
                  "active-offset": 50,
                  "rotate-x-max": 15,
                  "rotate-y-max": 15,
                  shadow: true,
                  highlight: true,
                  "rotate-x-invert": true,
                  "rotate-y-invert": true,
                  "shadow-scale": 1,
                  "rotate-touch": false,
                  class: "for-sale-atropos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("p", null, [
                            _createElementVNode("span", _hoisted_8, "Set: " + _toDisplayString(set.name), 1)
                          ]),
                          (character.created)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                                _createElementVNode("span", _hoisted_10, "Created: " + _toDisplayString(new Date(character.created * 1000).toDateString()), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (character.supply)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                                _createElementVNode("span", _hoisted_12, "Supply: " + _toDisplayString(character.supply), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (character.speed)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                                _createElementVNode("span", _hoisted_14, "Speed: " + _toDisplayString(character.speed), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (character.chattiness)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                                _createElementVNode("span", _hoisted_16, "Chattiness: " + _toDisplayString(character.chattiness), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (character.magic)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                                _createElementVNode("span", _hoisted_18, "Magic: " + _toDisplayString(character.magic), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (setKey === 'zoomers')
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: '/moonheads/' + character.key + '_350.jpeg'
                            }, null, 8, _hoisted_19))
                          : (_openBlock(), _createElementBlock("video", {
                              key: 1,
                              playsinline: "",
                              muted: "",
                              autoplay: "",
                              loop: "",
                              src: '/moonheads/' + character.key + '_350.mp4'
                            }, null, 8, _hoisted_20))
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("img", {
                                src: '/moonheads/sprites/' + character.key + '.png'
                              }, null, 8, _hoisted_25)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("p", _hoisted_27, _toDisplayString(character.name), 1),
                            _createElementVNode("div", _hoisted_28, [
                              (set.name === 'ZooMers')
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    target: "_blank",
                                    href: 
                            'https://opensea.io/assets/moonheads-zoomers?search[stringTraits][0][name]=Clan&search[stringTraits][0][values][0]=' +
                            character.name +
                            '&search[sortAscending]=true&search[sortBy]=PRICE'
                          ,
                                    class: "button is-medium is-light-green"
                                  }, "View Listings", 8, _hoisted_29))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    target: "_blank",
                                    href: 
                            'https://opensea.io/assets/moonheads?search[query]=' +
                            character.name +
                            '&search[resultModel]=ASSETS&search[sortAscending]=true&search[sortBy]=PRICE&search[toggles][0]=BUY_NOW'
                          ,
                                    class: "button is-medium is-light-green"
                                  }, "View Listings", 8, _hoisted_30))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}